export default "__VITE_ASSET__CSav_U6___"